export enum FieldSize {
    SMALL = "small",
    MEDIUM = "medium",
}

export enum FileUploadStatus {
    PENDING = "PENDING",
    UPLOADING = "UPLOADING",
    UPLOADED = "UPLOADED",
    VALIDATION_FAILED = "VALIDATION_FAILED",
    UPLOAD_FAILED = "UPLOAD_FAILED",
}
